import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

interface AddHandlingUnitNoteModalProps {
  visible: boolean;
  onHide: () => void;
  onSave: (note: string) => void;
  currentNote?: string;
}

const AddHandlingUnitNoteModal: React.FC<AddHandlingUnitNoteModalProps> = ({
  visible,
  onHide,
  onSave,
  currentNote = ''
}) => {
  const [note, setNote] = useState(currentNote);

  const handleSave = () => {
    onSave(note);
    onHide();
  };

  const footer = (
    <div>
      <Button 
        label="Cancel" 
        icon="pi pi-times" 
        onClick={onHide} 
        className="p-button-text" 
      />
      <Button 
        label="Save" 
        icon="pi pi-check" 
        onClick={handleSave}
        autoFocus 
      />
    </div>
  );

  return (
    <Dialog
      header="Add/Edit Note"
      visible={visible}
      onHide={onHide}
      style={{ width: '500px' }}
      footer={footer}
      modal
      className="p-fluid"
    >
      <div className="mt-2">
        <InputTextarea
          autoFocus
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter note for this handling unit..."
          className="w-full"
        />
      </div>
    </Dialog>
  );
};

export default AddHandlingUnitNoteModal;
